module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAABAElEQVRYhc2YLQzCMBBGK/nptiBJUFgsEotFYJFYLEFhsUgkJOO6IBAk7EpYAkFhkRgEFomdGBWsm8HuY8lL5vpyd23vKsrsN9CI9MdhFRliR6uLo/2eKOizEmbhkyHJIzUd3VB1i5RIfiGZdoYOVMLCtDGRaWMlsjStqlq1oBKWQ7DwImpiJdLIhDSv6G0dKvGtl9gw8/ZUw0nYelFvqYOpOC9LMIkMehnGYAkbmacb0ggqYWVY3SUHQ6hEroBvLtMAK5Gl6Sr1ug+VyNJEE7yEVg+8BP+FBDAd2MJEblHoYQU+toEXGPYqRzc12PYO2ehiW37k8FPkGIgfiNFPAx92F0CakxBzGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/next.png
// module id = CBlF
// module chunks = 1